<template>
  <div class="space-y-2">
    <Alert v-for="alert in alerts" :key="alert.key" :type="alert.severity">
      <template v-if="alert.severity === 'warning'" #icon>
        <ExclamationCircleIcon class="h-5 w-5 text-yellow-400" aria-hidden="true" />
      </template>
      {{ t(alert.key, alert.params || {}) }}
    </Alert>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { ExclamationCircleIcon } from "@heroicons/vue/solid";
import { Alert } from "@estaly/ui";

export default {
  components: { Alert, ExclamationCircleIcon },

  props: {
    alerts: {
      type: Array,
      default: () => [],
    },
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },
};
</script>

<i18n src="./InvoiceQuotationAlerts.i18n.json"></i18n>
